export const classes = {
  iconButton:
    'rounded-full size-10 place-center cursor-pointer hover:bg-black/5 dark:hover:bg-white/10 bg-transparent transition-colors mx-2 group-data-[compact]/tile:size-7 group-data-[compact]/tile:mx-1',
};
